import { render, staticRenderFns } from "./MportfacilitiesForm.vue?vue&type=template&id=60ce2c1e"
import script from "./MportfacilitiesForm.vue?vue&type=script&lang=js"
export * from "./MportfacilitiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports